export default "/_next/static/images/magic-line-4-1abbb4ef6830b2a40cfc683df33fac89.svg";